import { styled } from "styled-components";

export const Score = styled.text`
  font-size: 20px;
`;
